export enum TrackingEventName {
  // Fired when we embed an external webview (i.e. Ryanair)
  viewed_webview = "viewed_webview",
  tapped_search_suggestion = "tapped_search_suggestion",
  launched_application = "launched_application",
}
